import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Confetti from 'react-confetti';
import StyledButton from '../Common/StyledButton';
import { CLIENTS_ROUTE, ONBOARDING_ROUTE } from '../../utils/routes';
import { onboardingActions } from '../../redux/onboarding/onboardingSlice';
import { useAppSelector } from '../../redux/hooks';
import { enableSubscription } from '../../redux/subscription/subscriptionSlice';
import { formatPlanName } from '../../utils/paymentUtills';

export default function SubscriptionSuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const coachId = useAppSelector((state) => state.coach.coach.id);
  const subscriptionPlanStatus = useAppSelector(
    (state) => state.coach.coach.subscriptionPlanStatus
  );
  const urlParams = new URLSearchParams(location.search);
  const sessionId = urlParams.get('session_id');
  let plan = '';

  if (subscriptionPlanStatus?.currentPlan) {
    plan = formatPlanName(subscriptionPlanStatus?.currentPlan);
  }

  useEffect(() => {
    if (sessionId && coachId) {
      dispatch(enableSubscription({ sessionId, coachId }));
    }
  }, [sessionId, coachId, dispatch]);

  const handleDismiss = () => {
    window.location.href = CLIENTS_ROUTE;
    dispatch(onboardingActions.openOnboardingSuccessModal());
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Grid
      display="flex"
      flexDirection="column"
      gap={9}
      alignItems="center"
      justifyContent="center"
      height="80vh"
      maxWidth={location.pathname === ONBOARDING_ROUTE ? 900 : 652}
      marginX="auto"
      marginY="auto"
    >
      <Confetti width={windowSize.width - 1} height={windowSize.height - 1} />
      <Box>
        <img src="/assets/icons/payment-success.svg" alt="Subscription Success" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Typography variant="title1Bold" color="primary">
            {t('payment.subscriptionSuccess')}
          </Typography>
        </Box>
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {t('payment.subscriptionSuccessDesc', { plan })}
          </Typography>
        </Box>
      </Box>

      <StyledButton paddingY={12} paddingX={46} onClick={handleDismiss}>
        {t('common.dismiss')}
      </StyledButton>
    </Grid>
  );
}
